"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserSchema = void 0;
const getUserSchema = ({ projectId, }) => ({
    schemaType: "object",
    properties: [
        {
            title: "サムネイル",
            propertyName: "photoURL",
            schema: { schemaType: "image", readOnly: true },
        },
        {
            title: "uid",
            propertyName: "uid",
            schema: { schemaType: "text", readOnly: true },
        },
        {
            title: "E-MAIL",
            propertyName: "email",
            schema: { schemaType: "text", readOnly: true },
        },
        {
            title: "表示名",
            propertyName: "displayName",
            schema: { schemaType: "text", readOnly: true },
        },
        {
            title: "システム権限",
            propertyName: "customClaims.role",
            schema: {
                schemaType: "selector",
                readOnly: true,
                options: [
                    {
                        title: "システム管理者",
                        value: "master",
                    },
                ],
            },
        },
        {
            title: "プロジェクト権限",
            propertyName: `customClaims.projectRoles.${projectId}`,
            schema: {
                schemaType: "selector",
                readOnly: true,
                options: [
                    {
                        title: "プロジェクト管理者",
                        value: "master",
                    },
                    {
                        title: "プロジェクトユーザ",
                        value: "user",
                    },
                ],
            },
        },
        {
            title: "認証方法",
            propertyName: "providerData",
            schema: {
                schemaType: "message",
                text: ({ value }) => {
                    return (value === null || value === void 0 ? void 0 : value.map((v) => v.providerId).join(", ")) || "";
                },
                readOnly: true,
            },
        },
        {
            title: "トークン更新日時",
            propertyName: "tokensValidAfterTime",
            schema: { schemaType: "datetime", readOnly: true },
        },
        {
            title: "アカウント作成日時",
            propertyName: "metadata.creationTime",
            schema: { schemaType: "datetime", readOnly: true },
        },
        {
            title: "最終利用日時",
            propertyName: "metadata.lastRefreshTime",
            schema: { schemaType: "datetime", readOnly: true },
        },
        {
            title: "最終ログイン日時",
            propertyName: "metadata.lastSignInTime",
            schema: { schemaType: "datetime", readOnly: true },
        },
    ],
});
exports.getUserSchema = getUserSchema;
